import { render } from "./Tabla_metricas.vue?vue&type=template&id=5c58ad25&scoped=true"
import script from "./Tabla_metricas.vue?vue&type=script&lang=js"
export * from "./Tabla_metricas.vue?vue&type=script&lang=js"

import "./Tabla_metricas.vue?vue&type=style&index=0&id=5c58ad25&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c58ad25"]])

export default __exports__